// extracted by mini-css-extract-plugin
export default {"container":"unauthorized_container__+Gsnj"};